import { render, staticRenderFns } from "./OrganizationWsStaffManage.vue?vue&type=template&id=1b180608"
import script from "./OrganizationWsStaffManage.vue?vue&type=script&lang=js"
export * from "./OrganizationWsStaffManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports